import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import {
  ModelPromptLibrary,
  type IModelCreatePromptLibraryRequest,
} from './dto/prompt-library.dto';
import { PromptLibraryRepository } from './prompt-library.repository';

export class PromptLibraryService extends BaseService {
  private promptLibraryRepository = new PromptLibraryRepository(
    this.api,
    this.configService
  );

  async getPromptLibrary(
    params: any
  ): Promise<IModelResponse<ModelPromptLibrary[]>> {
    let dataResult: IModelResponse<ModelPromptLibrary[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.promptLibraryRepository.getPromptLibrary(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(
          (e) => new ModelPromptLibrary(e)
        );
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getPromptLibrary', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, PromptLibraryService.name);
    }
    return dataResult;
  }

  async createPromptLibrary(
    params: IModelCreatePromptLibraryRequest
  ): Promise<ModelPromptLibrary | undefined> {
    let dataResult;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.promptLibraryRepository.createPromptLibrary(
        params
      );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelPromptLibrary(resData.data);
        console.log('createPromptLibrary', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, PromptLibraryService.name);
    }
    return dataResult;
  }

  async updatePromptLibrary(
    params: IModelCreatePromptLibraryRequest
  ): Promise<ModelPromptLibrary | undefined> {
    let dataResult;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.promptLibraryRepository.updatePromptLibrary(
        params
      );

      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelPromptLibrary(resData.data);
        console.log('updatePromptLibrary', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, PromptLibraryService.name);
    }
    return dataResult;
  }

  async deletePromptLibrary(id: string): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.promptLibraryRepository.deletePromptLibrary(id);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = resData.data;
        console.log('deletePromptLibrary', id, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage =
        err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage,
      });
      console.log(err, PromptLibraryService.name);
    }

    return dataResult;
  }
}
